import React from "react";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { PropaneSharp } from "@mui/icons-material";
import { validEmail } from "../../../../Constants/RegExp";
import Typography from '@mui/material/Typography';
import dayjs from 'dayjs';
import { CreateBooking } from "./Requests";
import {PulseLoader } from "react-spinners";
import {loadStripe} from '@stripe/stripe-js';
import {
  PaymentElement,
  Elements,
  CardElement,
  useStripe,
  useElements,
  PaymentRequestButtonElement
} from '@stripe/react-stripe-js';
import {
   CreatePaymentIntent,
} from './Requests';

const stripePromise = loadStripe("pk_test_51RQTiRHFQZanvNJaQG5QFLf5mT2X8Yf1V07I4Tpkt7prByE90bRRMUAoiLbyeYodj6tBIPWX7RF4abTtBkVgb9kW00oPAOjivi"); // Your Stripe publishable key
const CheckoutForm = (props) => {
  const stripe = useStripe();
  const elements = useElements();
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!stripe || !elements) {
      return;
    }

    setIsLoading(true);
    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        // Return URL where the customer should be redirected after payment
        // return_url: window.location.origin + "/payment-result",
      },
      redirect: "if_required",
    });
    console.log(error)

    if (error)
    {
      if (error.type === "validation_error") {
      }
      else{
                setMessage(error.message);
        props.bookingResult('failed')
      }
    
    } else{
        setMessage("Payment succeeded!");
        props.bookingResult('success')
    }

    setIsLoading(false);
  };
  return (
    <form className="booking-portal-step-wrapper">
      <div className="payment-container">
        <div className="card-element-wrapper">
            <div>
              {props.service.name} with {props.barber.name}
            </div>
            <div>
              {new Date(props.date).toDateString()} {props.time}
            </div>
            <div>
              £{Number(props.service.onlinePaymentAmount/100).toFixed(2)}
            </div>
        </div>
      </div>
      <div className="payment-container">
         <form className="card-form">
            <div className="card-element-wrapper">
               <PaymentElement />
            </div>

            <button onClick={handleSubmit} className="submit-button" disabled={isLoading || !stripe || !elements}>
               {isLoading ? "Processing..." : "Pay £" + Number(props.service.onlinePaymentAmount/100).toFixed(2)}
            </button>
            {message && <div>{message}</div>}
         </form>
      </div>
   </form>
  );
};


const StepFive = (props) => {
   const [clientSecret, setClientSecret] = useState("");
   const [bookingResult, setBookingResult] = useState(false)
   useEffect(() => {
     CreatePaymentIntentWrapper()
   }, []);
   
   function CreatePaymentIntentWrapper()
   {
      CreatePaymentIntent(props.barber.barberId, props.service.serviceId, props.timeId, props.service.duration, props.firstName, props.lastName, props.email, props.mobile, props.date, props.time).then((res) => {
         console.log(res.data)
         if (res.status === 200)
         {
            setClientSecret(res.data)
            // setIsLoading(false)
         }
      }).catch((error) => {
      })
   }
   console.log(props.service)
   props.bookingResult(bookingResult)
  const options = {
    clientSecret,
  };
  return clientSecret ? (
    <Elements stripe={stripePromise} options={options}>
      <CheckoutForm theme={props.theme} bookingResult={setBookingResult} service={props.service} date={props.date} barber={props.barber} time={props.time}/>
    </Elements>
  ) : (
    <div style={{height:"100vh"}}>
      <div style={{display:'flex', justifyContent:'center', alignItems: 'center'}}>
        <div style={{marginTop:"2rem"}}>        
          <PulseLoader 
          color={'#333'}
          // loading={days === null}
          size={25}
          aria-label="Loading Spinner"
          data-testid="loader"
          />
        </div>
      </div> 
    </div>
  );
};
export default StepFive;

